// extracted by mini-css-extract-plugin
export var phone = "_4c-0";
export var phoneDragging = "_4c-1";